import { render, staticRenderFns } from "./ProductExtraOption.vue?vue&type=template&id=3794a8ba&"
import script from "./ProductExtraOption.vue?vue&type=script&lang=js&"
export * from "./ProductExtraOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports